import { useGetAppealsQuery } from 'feature/appeals/redux/appeals.api'
import { TAppealInList } from 'feature/appeals/type'
import { useIsAuth } from 'feature/auth/hooks'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { getOrderLink } from 'feature/productOrder/types/OrderLink'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { MouseEventHandler, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useActions } from 'store/hooks'

export const useOrderBlock = () => {
  const [isOpenConsultModal, setIsOpenConsultModal] = useState(false)
  const [isOpenProductConsultModal, setIsOpenProductConsultModal] =
    useState(false)
  const [isOpenOrderTypeModal, setIsOpenOrderTypeModal] = useState(false)
  const isAuth = useIsAuth()
  const navigate = useNavigate()

  const { setCurrentEditConsultForm } = useActions()
  const { data } = useGetAppealsQuery(undefined, {
    skip: !isAuth,
  })
  const [isActiveAppealsExist, setActiveAppealsExist] = useState<boolean>(false)

  useEffect(() => {
    if (data) {
      const activeList = data
        .filter(
          (item: TAppealInList) =>
            item?.status.status !== 'COMPLETED' &&
            item?.status.status !== 'CANCELED',
        )
        .slice(0, 2)
      setActiveAppealsExist(activeList.length > 0)
    }
  }, [data])

  const handleCloseConsultModal = () => {
    removeModalScrollSafari(false)
    setIsOpenConsultModal(false)
  }
  const handleCloseProductConsultModal = () => {
    removeModalScrollSafari(false)
    setIsOpenProductConsultModal(false)
  }

  const handleOpenConsultModal: MouseEventHandler<HTMLButtonElement> = () => {
    setCurrentEditConsultForm(orderFormSpace.ConsultationFormType.consultation)
    removeModalScrollSafari(true)
    setIsOpenConsultModal(true)
  }

  const handleOrderClick = () => {
    if (isAuth) {
      navigate('/productorder')
    } else {
      setIsOpenOrderTypeModal(true)
    }
  }

  const handleOrderTypeSelect = (type: orderFormSpace.UserType) => {
    setIsOpenOrderTypeModal(false)
    if (type === 'company') {
      navigate('/company/login')
    } else {
      navigate(getOrderLink(orderFormSpace.FormType.new, type))
    }
  }

  return {
    handleCloseConsultModal,
    handleCloseProductConsultModal,
    handleOpenConsultModal,
    isOpenConsultModal,
    isOpenProductConsultModal,
    isActiveAppealsExist,
    isOpenOrderTypeModal,
    handleOrderClick,
    handleOrderTypeSelect,
    handleCloseOrderTypeModal: () => setIsOpenOrderTypeModal(false),
  }
}
